import { Link } from "react-router-dom";

export default function Footer() {
  const navLinks = [
    { label: "Home", href: "#home" },
    { label: "Services", href: "#services" },
    { label: "Products", href: "#works" },
    { label: "Portfolio", href: "#works" },
    { label: "Contact Us", href: "#contact" },
  ];

  const serviceLinks = [
    "Branding",
    "Web Design/Development",
    "Content Creation",
    "SEO",
    "Performance Marketing",
  ];

  const companyLinks = [
    "About Us",
    "Privacy Policy",
    "Terms of Service",
    "Careers",
  ];

  return (
    <footer data-testid="footer" className="bg-zinc-950 border-t border-white/5 pt-20 pb-10">
      <div className="container mx-auto px-6 md:px-12 max-w-[1400px]">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-16">
          {/* Navigation */}
          <div>
            <h4 className="font-syne text-sm font-bold text-white mb-6 uppercase tracking-[0.15em]">
              Navigation
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith("/") ? (
                    <Link
                      to={link.href}
                      className="text-sm text-zinc-500 hover:text-[#ff6b6b] transition-colors font-light"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-sm text-zinc-500 hover:text-[#ff6b6b] transition-colors font-light"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-syne text-sm font-bold text-white mb-6 uppercase tracking-[0.15em]">
              Services
            </h4>
            <ul className="space-y-3">
              {serviceLinks.map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    className="text-sm text-zinc-500 hover:text-[#ff6b6b] transition-colors font-light"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-syne text-sm font-bold text-white mb-6 uppercase tracking-[0.15em]">
              Company
            </h4>
            <ul className="space-y-3">
              {companyLinks.map((c) => (
                <li key={c}>
                  <a
                    href="#"
                    className="text-sm text-zinc-500 hover:text-[#ff6b6b] transition-colors font-light"
                  >
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/assets/logo.png" alt="DigiStromer" className="h-12 w-auto" />
            </div>
            <div className="space-y-2 mb-6">
              <p className="text-sm text-zinc-500 font-light">Info@digistromer.com</p>
              <p className="text-sm text-zinc-500 font-light">+971 50 648 5900</p>
            </div>
            <div className="flex flex-col gap-2">
              {["Instagram", "LinkedIn"].map((s) => (
                <a
                  key={s}
                  href="#"
                  className="text-sm text-zinc-500 hover:text-[#ff6b6b] transition-colors font-medium"
                >
                  {s}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-zinc-600 font-light">
            &copy; 2026 DigiStromer. All rights reserved.
          </p>
          <p className="text-xs text-zinc-600 font-light">
            Crafted with passion in Dubai, UAE
          </p>
        </div>
      </div>
    </footer>
  );
}
